// packages/kern/src/icons.ts — die 14 Piktogramme (SPEC §3.7).
//
// KEIN DOM: außer `text-canvas.ts` darf keine Datei in `packages/kern/src`
// `document`, `window`, `navigator`, `fetch`, `localStorage` oder einen
// React-Import enthalten.
//
// Wortgleich aus `docs/quellen/understand/prototype.json`,
// reusable_snippets[5] („Konstanten, Layout-Metriken, STYLES, ICONS,
// ICON_ORDER"), Block `const ICONS={ … }`. Jede Zahl einzeln abgeschrieben;
// die `circ(...)`-Aufrufe BLEIBEN Aufrufe — sie erzeugen den Pfad zur
// Ladezeit, damit die Zeichenkette garantiert dieselbe ist wie im Prototyp.
//
// Marken: "f" = Füllung in PETROL, "p" = Füllung in PAPER (die Aussparung im
// Standort-Pin), "s" = Strich in PETROL mit `stroke-width` aus dem dritten
// Feld (Standard 2), dazu `stroke-linecap: round` und `stroke-linejoin: round`.
//
// Diese 14 Zeichnungen sind Teil des Druckerzeugnisses und werden NICHT durch
// Phosphor-Symbole ersetzt. Phosphor zeichnet nur die Bedienoberfläche.

import type { PiktogrammKey } from "./types";

export type IconPfad = ["f", string] | ["p", string] | ["s", string, number?];

export const circ = (cx: number, cy: number, r: number): string =>
  "M" + (cx - r) + " " + cy + "a" + r + " " + r + " 0 1 0 " + 2 * r + " 0a" + r + " " + r + " 0 1 0 " + -2 * r + " 0";

export const ICONS: Record<PiktogrammKey, IconPfad[] | null> = {
  none: null,
  // Die Zeichnung steht im Eintrag (`eigenesIcon`), nicht hier (T44).
  eigen: null,
  megafon: [["f", "M2 9.5h4.5L15 4v16L6.5 14.5H2z"], ["f", "M6.9 14.9l1.3 5.1h2.9l-1.4-5.1z"],
            ["s", "M17.4 8.6a5.2 5.2 0 0 1 0 6.8", 1.9], ["s", "M19.9 6.3a8.7 8.7 0 0 1 0 11.4", 1.9]],
  gruppe: [["f", circ(5.4, 9, 2.7)], ["f", circ(18.6, 9, 2.7)],
           ["f", "M.9 19.6c0-2.5 2-4.5 4.5-4.5s4.5 2 4.5 4.5z"], ["f", "M14.1 19.6c0-2.5 2-4.5 4.5-4.5s4.5 2 4.5 4.5z"],
           ["f", circ(12, 7.4, 3.5)], ["f", "M5.1 21.4c0-3.2 3.1-5.8 6.9-5.8s6.9 2.6 6.9 5.8z"]],
  ausruf: [["f", "M10.3 2.4h3.4l-.6 12.4h-2.2z"], ["f", circ(12, 19.6, 2)]],
  kalender: [["s", "M2.7 7.2a2 2 0 0 1 2-2h14.6a2 2 0 0 1 2 2v12.6a2 2 0 0 1-2 2H4.7a2 2 0 0 1-2-2z", 1.8],
             ["s", "M2.7 10.7h18.6", 1.8], ["s", "M7.6 2.6v4.4", 1.8], ["s", "M16.4 2.6v4.4", 1.8]],
  haken: [["s", "M3.6 12.7l5.6 5.7L20.4 6.4", 2.4]],
  stift: [["f", "M2.9 21.1l1.1-4.5L14.9 5.7l3.4 3.4L7.4 20z"],
          ["f", "M16.3 4.3l1.6-1.6a1.7 1.7 0 0 1 2.4 0l1 1a1.7 1.7 0 0 1 0 2.4l-1.6 1.6z"]],
  idee: [["f", "M12 2.1a7 7 0 0 0-4.3 12.5c.8.6 1.2 1.4 1.2 2.3h6.2c0-.9.4-1.7 1.2-2.3A7 7 0 0 0 12 2.1z"],
         ["f", "M8.9 18.2h6.2v1.7H8.9z"], ["s", "M10.1 21.4h3.8", 1.8]],
  blase: [["s", "M1.7 6a1.8 1.8 0 0 1 1.8-1.8h17a1.8 1.8 0 0 1 1.8 1.8v9.1a1.8 1.8 0 0 1-1.8 1.8h-7.9L7.9 21.2v-4.3H3.5A1.8 1.8 0 0 1 1.7 15.1z", 1.8]],
  flagge: [["s", "M5 2.2v19.6", 2.1], ["f", "M6.5 3.3c4-1.6 7 1.6 11 0v7.7c-4 1.6-7-1.6-11 0z"]],
  standort: [["f", "M12 2.1a7.1 7.1 0 0 0-7.1 7.1c0 5.1 7.1 12.7 7.1 12.7s7.1-7.6 7.1-12.7A7.1 7.1 0 0 0 12 2.1z"],
             ["p", circ(12, 9.2, 2.6)]],
  dokument: [["s", "M5.6 2.6h7.9L18.8 8v13.4H5.6z", 1.8], ["s", "M13.3 2.8v5.4h5.4", 1.8],
             ["s", "M8.5 12.6h7.2", 1.6], ["s", "M8.5 16.1h7.2", 1.6]],
  lupe: [["s", circ(10.6, 10.6, 6.6), 2], ["s", "M15.4 15.4l6 6", 2.6]],
  uhr: [["s", circ(12, 12, 9), 2], ["s", "M12 6.4V12l3.9 2.4", 2]],
};

export const ICON_ORDER: PiktogrammKey[] = ["none", "megafon", "gruppe", "ausruf", "kalender", "haken", "stift", "idee", "blase", "flagge", "standort", "dokument", "lupe", "uhr"];
